module.exports = __webpack_public_path__ + "img/tee.9d2f8864.svg";